import PropTypes from 'prop-types'

export const timeSliceGenerateResponsePropType = PropTypes.shape({
    dayOfYear: PropTypes.number,
    monthOfYear: PropTypes.number,
    year: PropTypes.number
})
